import { Spinner } from "components/individual/Spinner/Spinner";
import { saveAs } from "file-saver";
import { downloadTemplate } from "helpers/Apis/setUp";
import React, { useState } from "react";

/**
 * Render a item to download the excel report on click action
 * @param {import("./types").PropsReminderPayments} props
 * @returns {JSX.Element}
 */
export default function ReminderPayments({ children = <></>, type = "pagos" }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);

    const filename = new Date().toLocaleString("es-MX", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const indexedNames = {
      ["pagos"]: "Programación de pagos",
      control: "Reporte de control",
      "opGlobal":"Operación global"
    };

    downloadTemplate(type)
      .then((file) =>
        saveAs(file, `${indexedNames[type] || "Reporte"} ${filename}.xlsx`)
      )
      .finally(() => setLoading(false));
  };

  if (loading) return <div>Descargando</div>;

  return <div onClick={handleDownload}>{children}</div>;
}
